
class Storage {

	unset (key) {
		return localStorage.removeItem(key);
	}

	set (key, value) {
		return localStorage.setItem(key, JSON.stringify(value));
	}

	get (key) {
		try {
			return JSON.parse(localStorage.getItem(key));
		} catch (e) {}
	}

}

Storage.$inject = [];

export default angular.module('service.storage', [])
	.service('Storage', Storage)
	.name;



// WEBPACK FOOTER //
// ./src/service/storage.js